exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btnsGroup[data-v-71c8afa0] {\n  padding-top: 0.020833rem;\n  padding-left: 0.052083rem;\n}\n.majorWarp[data-v-71c8afa0] {\n  border: 0.005208rem solid var(--bgc);\n  padding: 0.104167rem 0.026042rem;\n  margin-bottom: 0.104167rem;\n}", ""]);

// exports
